module.exports = __webpack_public_path__ + "img/sticker_21.3c74995e.svg";